import { render } from "./phone-input.vue?vue&type=template&id=533a7d03&ts=true"
import script from "./phone-input.vue?vue&type=script&lang=ts"
export * from "./phone-input.vue?vue&type=script&lang=ts"

import exportComponent from "/geosite/web/geosite-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__